export * from './hooks/index.js';
export type { DSMaskT } from './react-desc-prop-types.js';
export type { UseMaskT, UseNumberMaskT, UsePhoneMaskT, UseRegExpMaskT } from './react-desc-prop-types.js';
